import React, { useRef, useState } from "react";

export default function LogoUploader({ onFileSelect, previewUrl }) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFile = (file) => {
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Please upload a PNG, JPG or WEBP image.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Image size must be less than 5 MB.");
      return;
    }

    onFileSelect(file);
  };

  const handleInputChange = (e) => {
    handleFile(e.target.files?.[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  return (
    <div className="logo-uploader">
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/webp"
        onChange={handleInputChange}
        hidden
      />

      {!previewUrl ? (
        <div
          className={`logo-upload-area ${
            isDragging ? "logo-upload-dragging" : ""
          }`}
          onClick={() => inputRef.current?.click()}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          <div className="logo-upload-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 16V4" />
              <path d="M7 9l5-5 5 5" />
              <path d="M4 20h16" />
            </svg>
          </div>

          <div className="logo-upload-title">
            Upload Logo / Image
          </div>

          <div className="logo-upload-description">
            Drag & drop your image here
          </div>

          <button
            type="button"
            className="logo-choose-btn"
            onClick={(e) => {
              e.stopPropagation();
              inputRef.current?.click();
            }}
          >
            Choose Image
          </button>

          <div className="logo-upload-format">
            PNG, JPG or WEBP · Maximum 5 MB
          </div>
        </div>
      ) : (
        <div className="logo-upload-preview">
          <div className="logo-preview-image-box">
            <img
              src={previewUrl}
              alt="Logo preview"
              className="logo-preview-image"
            />
          </div>

          <div className="logo-preview-details">
            <div className="logo-preview-title">
              Logo selected
            </div>

            <div className="logo-preview-text">
              Your logo will be placed in the center of the QR code.
            </div>

            <button
              type="button"
              className="logo-change-btn"
              onClick={() => inputRef.current?.click()}
            >
              Change Image
            </button>
          </div>
        </div>
      )}
    </div>
  );
}